import { createSlice } from "@reduxjs/toolkit";
import Swal from 'sweetalert2';
import { getDoctor, submitDoctor, deleteDoctor } from "./Utils/doctorUtils";

const initialState = {
    filters: {
        "filter[id]": "",
        "filter[name]": "",
        "sort": "-id",
        "page": "",
        "include": "",
    },
    doctors: [],
    pagination: {},
    loading: false,
    error: null,
    currentDoctor: {  // Ini buat menyimpan data form yang lagi aktif
        id: null,
        name: "",
        profile_picture: null,
    }
};

const doctorSlice = createSlice({
    name: "doctor",
    initialState,
    reducers: {
        setFormData: (state, action) => {
            state.currentDoctor = { ...state.currentDoctor, ...action.payload };
        },
        resetFormData: (state) => {
            state.currentDoctor = initialState.currentDoctor;
        },
        setFilters: (state, action) => {
            state.filters = { ...state.filters, ...action.payload };
        }
    },
    extraReducers: (builder) => {
        builder
            // Handle getDoctor
            .addCase(getDoctor.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getDoctor.fulfilled, (state, action) => {
                state.loading = false;
                state.doctors = action.payload.data;
                state.pagination = action.payload.pagination;
            })
            .addCase(getDoctor.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            // Handle submitDoctor
            .addCase(submitDoctor.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(submitDoctor.fulfilled, (state, action) => {
                state.loading = false;
                Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: 'Data berhasil disimpan'
                });
            })
            .addCase(submitDoctor.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            // Handle deleteDoctor
            .addCase(deleteDoctor.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(deleteDoctor.fulfilled, (state, action) => {
                state.loading = false;
                Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: 'Data berhasil dihapus'
                });
                state.doctors = state.doctors.filter(doctor => doctor.id !== action.payload.id);
            })
            .addCase(deleteDoctor.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
    }
});

export const { setFormData, resetFormData, setFilters } = doctorSlice.actions;
export default doctorSlice.reducer;